import { gql } from "graphql-tag"

export const searchTMDB = gql`
  query searchTMDB($query: String!, $type: SearchType, $page: Int) {
    searchTMDB(searchTMDBInput: { query: $query, type: $type, page: $page }) {
      id
      title
      year
      mediaType
      poster
      overview
      externalIds {
        imdbId
      }
    }
  }
`

export default searchTMDB
